import { render, staticRenderFns } from "./WaitingforCommercializingPhds.vue?vue&type=template&id=264dc6a8&"
import script from "./WaitingforCommercializingPhds.vue?vue&type=script&lang=js&"
export * from "./WaitingforCommercializingPhds.vue?vue&type=script&lang=js&"
import style0 from "./WaitingforCommercializingPhds.vue?vue&type=style&index=0&id=264dc6a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports